"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBDualCardPositive = function SvgBDualCardPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M132.108 110.48H31.694c-6.37-.008-11.533-5.17-11.541-11.541V75.273a2.107 2.107 0 114.215 0V98.94a7.333 7.333 0 007.326 7.326h100.449a7.333 7.333 0 007.326-7.326V44.724a7.333 7.333 0 00-7.326-7.326h-3.45a2.107 2.107 0 010-4.215h3.45c6.357.027 11.498 5.184 11.506 11.541V98.94c-.008 6.37-5.17 11.533-11.541 11.54z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M48.63 87.229H35.347a2.107 2.107 0 110-4.215H48.63a2.107 2.107 0 010 4.215zM65.207 97.182h-29.86a2.107 2.107 0 110-4.214h29.86a2.107 2.107 0 110 4.214zM115.038 97.182h-3.35a2.107 2.107 0 010-4.214h3.33a2.107 2.107 0 010 4.214h.02zM128.293 97.182h-3.33a2.107 2.107 0 010-4.214h3.33a2.107 2.107 0 010 4.214zM22.288 77.184H11.541C5.171 77.176.008 72.014 0 65.643a2.107 2.107 0 014.215 0 7.333 7.333 0 007.326 7.326h10.747a2.107 2.107 0 110 4.215z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M2.107 67.75A2.107 2.107 0 010 65.643V31.926a2.107 2.107 0 114.215 0v33.717a2.107 2.107 0 01-2.108 2.107z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M128.926 37.398H15.454a2.107 2.107 0 010-4.215h113.472a2.107 2.107 0 010 4.215zM25.337 50.576h-9.883a2.107 2.107 0 010-4.215h9.883a2.107 2.107 0 110 4.215zM48.602 50.576h-9.905a2.107 2.107 0 110-4.215h9.905a2.107 2.107 0 110 4.215z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M111.955 77.184h-76.65a2.107 2.107 0 010-4.215h76.65a7.34 7.34 0 007.333-7.326V11.555a7.34 7.34 0 00-7.333-7.34H11.54a7.333 7.333 0 00-7.326 7.326 2.107 2.107 0 01-4.215 0C.008 5.171 5.17.008 11.541 0H111.99c6.372.008 11.536 5.17 11.548 11.541V65.63a11.562 11.562 0 01-11.583 11.555z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M108.26 24.115H2.107A2.107 2.107 0 010 22.007V11.541C.008 5.171 5.17.008 11.541 0h33.633a2.107 2.107 0 010 4.215H11.54a7.333 7.333 0 00-7.326 7.326v8.36H108.26a2.107 2.107 0 110 4.214z",
    fill: "#285"
  })));
};

var _default = SvgBDualCardPositive;
exports["default"] = _default;